type NeuroIDFunction = (x: string, y?: string) => void;
type NeuroID = NeuroIDFunction & { q?: [x: string, y?: string][] };

declare global {
  interface Window {
    nid?: NeuroID;
  }
}

const SCRIPT_ID = "neuro-id-init";

function buildNeuroIDBootstrapScript(siteId: string): string {
  return `(function(n,e,u,r,o,i,d){
    n.nid=n.nid||function(){(n.nid.q=n.nid.q||[]).push(arguments)};
    o=e.createElement(u);i=e.getElementsByTagName(u)[0];o.async=1;
    o.src=r;i.parentNode.insertBefore(o,i);
  })(window,document,"script","//scripts.neuro-id.com/c/${siteId}.js");`;
}

export function ensureNeuroIDBootstrapScript(siteId: string) {
  if (typeof window === "undefined") {
    return;
  }

  if (document.getElementById(SCRIPT_ID)) {
    return;
  }

  const script = document.createElement("script");
  script.id = SCRIPT_ID;
  script.text = buildNeuroIDBootstrapScript(siteId);
  document.head.appendChild(script);
}

export function identifyApplication(applicationUuid: string) {
  if (typeof window === "undefined" || !applicationUuid) {
    return;
  }

  // The script bootstrap above always assigns window.nid as a queueing stub,
  // so by the time we reach here window.nid is callable even if the remote
  // script hasn't finished loading.
  if (!window.nid) {
    return;
  }

  window.nid("identify", applicationUuid);
}
